module.exports = __webpack_public_path__ + "static/img/3-2-3.ff00a74c.jpg";